"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = _interopRequireDefault(require("react"));
var _reactSwitch = _interopRequireDefault(require("react-switch"));
var _eero = require("../../theme/eero");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function cov_1m6kyt7rqi() {
  var path = "/__w/code/code/js/packages/bricks/src/complex/Switch/Switch.tsx";
  var hash = "8592f49d842444d72e57cb879bdd47794786e2d0";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/complex/Switch/Switch.tsx",
    statementMap: {
      "0": {
        start: {
          line: 16,
          column: 19
        },
        end: {
          line: 23,
          column: 1
        }
      },
      "1": {
        start: {
          line: 25,
          column: 19
        },
        end: {
          line: 27,
          column: 1
        }
      },
      "2": {
        start: {
          line: 29,
          column: 20
        },
        end: {
          line: 31,
          column: 1
        }
      },
      "3": {
        start: {
          line: 33,
          column: 21
        },
        end: {
          line: 46,
          column: 1
        }
      },
      "4": {
        start: {
          line: 34,
          column: 2
        },
        end: {
          line: 45,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 33,
            column: 21
          },
          end: {
            line: 33,
            column: 22
          }
        },
        loc: {
          start: {
            line: 34,
            column: 2
          },
          end: {
            line: 45,
            column: 4
          }
        },
        line: 34
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 37,
            column: 13
          },
          end: {
            line: 37,
            column: 55
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 37,
            column: 27
          },
          end: {
            line: 37,
            column: 38
          }
        }, {
          start: {
            line: 37,
            column: 41
          },
          end: {
            line: 37,
            column: 55
          }
        }],
        line: 37
      },
      "1": {
        loc: {
          start: {
            line: 39,
            column: 19
          },
          end: {
            line: 39,
            column: 79
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 39,
            column: 42
          },
          end: {
            line: 39,
            column: 71
          }
        }, {
          start: {
            line: 39,
            column: 74
          },
          end: {
            line: 39,
            column: 79
          }
        }],
        line: 39
      },
      "2": {
        loc: {
          start: {
            line: 40,
            column: 17
          },
          end: {
            line: 40,
            column: 76
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 40,
            column: 40
          },
          end: {
            line: 40,
            column: 68
          }
        }, {
          start: {
            line: 40,
            column: 71
          },
          end: {
            line: 40,
            column: 76
          }
        }],
        line: 40
      },
      "3": {
        loc: {
          start: {
            line: 43,
            column: 11
          },
          end: {
            line: 43,
            column: 41
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 43,
            column: 34
          },
          end: {
            line: 43,
            column: 36
          }
        }, {
          start: {
            line: 43,
            column: 39
          },
          end: {
            line: 43,
            column: 41
          }
        }],
        line: 43
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "8592f49d842444d72e57cb879bdd47794786e2d0"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1m6kyt7rqi = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1m6kyt7rqi();
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var SwitchIcon = (cov_1m6kyt7rqi().s[0]++, /*#__PURE__*/(0, _base["default"])("div", process.env.NODE_ENV === "production" ? {
  target: "e1pwwhvv2"
} : {
  target: "e1pwwhvv2",
  label: "SwitchIcon"
})("display:flex;align-items:center;justify-content:center;height:100%;color:", _eero.colors.neutrals0, ";font-size:12px;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wbGV4L1N3aXRjaC9Td2l0Y2gudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWU2QiIsImZpbGUiOiIuLi8uLi8uLi9zcmMvY29tcGxleC9Td2l0Y2gvU3dpdGNoLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgU3dpdGNoLCB7IFJlYWN0U3dpdGNoUHJvcHMgfSBmcm9tICdyZWFjdC1zd2l0Y2gnO1xuXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmltcG9ydCB7IGNvbG9ycyB9IGZyb20gJy4uLy4uL3RoZW1lL2Vlcm8nO1xuXG5leHBvcnQgaW50ZXJmYWNlIElTd2l0Y2hQcm9wcyB7XG4gIGNoZWNrZWQ6IGJvb2xlYW47XG4gIG9uQ2hhbmdlOiBSZWFjdFN3aXRjaFByb3BzWydvbkNoYW5nZSddO1xuICBjb2xvcj86IHN0cmluZztcbiAgc2hvd1llc05vTGFiZWw/OiBib29sZWFuO1xuICBkaWFtZXRlcj86IG51bWJlcjtcbn1cblxuY29uc3QgU3dpdGNoSWNvbiA9IHN0eWxlZC5kaXZgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICBoZWlnaHQ6IDEwMCU7XG4gIGNvbG9yOiAke2NvbG9ycy5uZXV0cmFsczB9O1xuICBmb250LXNpemU6IDEycHg7XG5gO1xuXG5jb25zdCBTd2l0Y2hMZWZ0ID0gc3R5bGVkKFN3aXRjaEljb24pYFxuICB0cmFuc2Zvcm06IHRyYW5zbGF0ZSgxcHgpO1xuYDtcblxuY29uc3QgU3dpdGNoUmlnaHQgPSBzdHlsZWQoU3dpdGNoSWNvbilgXG4gIHRyYW5zZm9ybTogdHJhbnNsYXRlKC0xcHgpO1xuYDtcblxuY29uc3QgQnJpY2tzU3dpdGNoID0gKHByb3BzOiBJU3dpdGNoUHJvcHMpID0+IChcbiAgPFN3aXRjaFxuICAgIGNoZWNrZWQ9e3Byb3BzLmNoZWNrZWR9XG4gICAgb25DaGFuZ2U9e3Byb3BzLm9uQ2hhbmdlfVxuICAgIG9uQ29sb3I9e3Byb3BzLmNvbG9yID8gcHJvcHMuY29sb3IgOiBjb2xvcnMuYnJhbmQ1MH1cbiAgICBvZmZDb2xvcj17Y29sb3JzLm5ldXRyYWxzNzB9XG4gICAgdW5jaGVja2VkSWNvbj17cHJvcHMuc2hvd1llc05vTGFiZWwgPyA8U3dpdGNoUmlnaHQ+Tm88L1N3aXRjaFJpZ2h0PiA6IGZhbHNlfVxuICAgIGNoZWNrZWRJY29uPXtwcm9wcy5zaG93WWVzTm9MYWJlbCA/IDxTd2l0Y2hMZWZ0PlllczwvU3dpdGNoTGVmdD4gOiBmYWxzZX1cbiAgICBhY3RpdmVCb3hTaGFkb3c9e3Byb3BzLmNvbG9yfVxuICAgIGhlaWdodD17MjV9XG4gICAgd2lkdGg9e3Byb3BzLnNob3dZZXNOb0xhYmVsID8gNTAgOiA0NX1cbiAgICBoYW5kbGVEaWFtZXRlcj17cHJvcHMuZGlhbWV0ZXJ9XG4gIC8+XG4pO1xuXG5leHBvcnQgZGVmYXVsdCBCcmlja3NTd2l0Y2g7XG4iXX0= */")));
var SwitchLeft = (cov_1m6kyt7rqi().s[1]++, /*#__PURE__*/(0, _base["default"])(SwitchIcon, process.env.NODE_ENV === "production" ? {
  target: "e1pwwhvv1"
} : {
  target: "e1pwwhvv1",
  label: "SwitchLeft"
})(process.env.NODE_ENV === "production" ? {
  name: "1iwydhh",
  styles: "transform:translate(1px)"
} : {
  name: "1iwydhh",
  styles: "transform:translate(1px)",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wbGV4L1N3aXRjaC9Td2l0Y2gudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXdCcUMiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL2NvbXBsZXgvU3dpdGNoL1N3aXRjaC50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IFN3aXRjaCwgeyBSZWFjdFN3aXRjaFByb3BzIH0gZnJvbSAncmVhY3Qtc3dpdGNoJztcblxuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG5pbXBvcnQgeyBjb2xvcnMgfSBmcm9tICcuLi8uLi90aGVtZS9lZXJvJztcblxuZXhwb3J0IGludGVyZmFjZSBJU3dpdGNoUHJvcHMge1xuICBjaGVja2VkOiBib29sZWFuO1xuICBvbkNoYW5nZTogUmVhY3RTd2l0Y2hQcm9wc1snb25DaGFuZ2UnXTtcbiAgY29sb3I/OiBzdHJpbmc7XG4gIHNob3dZZXNOb0xhYmVsPzogYm9vbGVhbjtcbiAgZGlhbWV0ZXI/OiBudW1iZXI7XG59XG5cbmNvbnN0IFN3aXRjaEljb24gPSBzdHlsZWQuZGl2YFxuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgaGVpZ2h0OiAxMDAlO1xuICBjb2xvcjogJHtjb2xvcnMubmV1dHJhbHMwfTtcbiAgZm9udC1zaXplOiAxMnB4O1xuYDtcblxuY29uc3QgU3dpdGNoTGVmdCA9IHN0eWxlZChTd2l0Y2hJY29uKWBcbiAgdHJhbnNmb3JtOiB0cmFuc2xhdGUoMXB4KTtcbmA7XG5cbmNvbnN0IFN3aXRjaFJpZ2h0ID0gc3R5bGVkKFN3aXRjaEljb24pYFxuICB0cmFuc2Zvcm06IHRyYW5zbGF0ZSgtMXB4KTtcbmA7XG5cbmNvbnN0IEJyaWNrc1N3aXRjaCA9IChwcm9wczogSVN3aXRjaFByb3BzKSA9PiAoXG4gIDxTd2l0Y2hcbiAgICBjaGVja2VkPXtwcm9wcy5jaGVja2VkfVxuICAgIG9uQ2hhbmdlPXtwcm9wcy5vbkNoYW5nZX1cbiAgICBvbkNvbG9yPXtwcm9wcy5jb2xvciA/IHByb3BzLmNvbG9yIDogY29sb3JzLmJyYW5kNTB9XG4gICAgb2ZmQ29sb3I9e2NvbG9ycy5uZXV0cmFsczcwfVxuICAgIHVuY2hlY2tlZEljb249e3Byb3BzLnNob3dZZXNOb0xhYmVsID8gPFN3aXRjaFJpZ2h0Pk5vPC9Td2l0Y2hSaWdodD4gOiBmYWxzZX1cbiAgICBjaGVja2VkSWNvbj17cHJvcHMuc2hvd1llc05vTGFiZWwgPyA8U3dpdGNoTGVmdD5ZZXM8L1N3aXRjaExlZnQ+IDogZmFsc2V9XG4gICAgYWN0aXZlQm94U2hhZG93PXtwcm9wcy5jb2xvcn1cbiAgICBoZWlnaHQ9ezI1fVxuICAgIHdpZHRoPXtwcm9wcy5zaG93WWVzTm9MYWJlbCA/IDUwIDogNDV9XG4gICAgaGFuZGxlRGlhbWV0ZXI9e3Byb3BzLmRpYW1ldGVyfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQnJpY2tzU3dpdGNoO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
}));
var SwitchRight = (cov_1m6kyt7rqi().s[2]++, /*#__PURE__*/(0, _base["default"])(SwitchIcon, process.env.NODE_ENV === "production" ? {
  target: "e1pwwhvv0"
} : {
  target: "e1pwwhvv0",
  label: "SwitchRight"
})(process.env.NODE_ENV === "production" ? {
  name: "1rrxkby",
  styles: "transform:translate(-1px)"
} : {
  name: "1rrxkby",
  styles: "transform:translate(-1px)",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wbGV4L1N3aXRjaC9Td2l0Y2gudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQTRCc0MiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL2NvbXBsZXgvU3dpdGNoL1N3aXRjaC50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IFN3aXRjaCwgeyBSZWFjdFN3aXRjaFByb3BzIH0gZnJvbSAncmVhY3Qtc3dpdGNoJztcblxuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG5pbXBvcnQgeyBjb2xvcnMgfSBmcm9tICcuLi8uLi90aGVtZS9lZXJvJztcblxuZXhwb3J0IGludGVyZmFjZSBJU3dpdGNoUHJvcHMge1xuICBjaGVja2VkOiBib29sZWFuO1xuICBvbkNoYW5nZTogUmVhY3RTd2l0Y2hQcm9wc1snb25DaGFuZ2UnXTtcbiAgY29sb3I/OiBzdHJpbmc7XG4gIHNob3dZZXNOb0xhYmVsPzogYm9vbGVhbjtcbiAgZGlhbWV0ZXI/OiBudW1iZXI7XG59XG5cbmNvbnN0IFN3aXRjaEljb24gPSBzdHlsZWQuZGl2YFxuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgaGVpZ2h0OiAxMDAlO1xuICBjb2xvcjogJHtjb2xvcnMubmV1dHJhbHMwfTtcbiAgZm9udC1zaXplOiAxMnB4O1xuYDtcblxuY29uc3QgU3dpdGNoTGVmdCA9IHN0eWxlZChTd2l0Y2hJY29uKWBcbiAgdHJhbnNmb3JtOiB0cmFuc2xhdGUoMXB4KTtcbmA7XG5cbmNvbnN0IFN3aXRjaFJpZ2h0ID0gc3R5bGVkKFN3aXRjaEljb24pYFxuICB0cmFuc2Zvcm06IHRyYW5zbGF0ZSgtMXB4KTtcbmA7XG5cbmNvbnN0IEJyaWNrc1N3aXRjaCA9IChwcm9wczogSVN3aXRjaFByb3BzKSA9PiAoXG4gIDxTd2l0Y2hcbiAgICBjaGVja2VkPXtwcm9wcy5jaGVja2VkfVxuICAgIG9uQ2hhbmdlPXtwcm9wcy5vbkNoYW5nZX1cbiAgICBvbkNvbG9yPXtwcm9wcy5jb2xvciA/IHByb3BzLmNvbG9yIDogY29sb3JzLmJyYW5kNTB9XG4gICAgb2ZmQ29sb3I9e2NvbG9ycy5uZXV0cmFsczcwfVxuICAgIHVuY2hlY2tlZEljb249e3Byb3BzLnNob3dZZXNOb0xhYmVsID8gPFN3aXRjaFJpZ2h0Pk5vPC9Td2l0Y2hSaWdodD4gOiBmYWxzZX1cbiAgICBjaGVja2VkSWNvbj17cHJvcHMuc2hvd1llc05vTGFiZWwgPyA8U3dpdGNoTGVmdD5ZZXM8L1N3aXRjaExlZnQ+IDogZmFsc2V9XG4gICAgYWN0aXZlQm94U2hhZG93PXtwcm9wcy5jb2xvcn1cbiAgICBoZWlnaHQ9ezI1fVxuICAgIHdpZHRoPXtwcm9wcy5zaG93WWVzTm9MYWJlbCA/IDUwIDogNDV9XG4gICAgaGFuZGxlRGlhbWV0ZXI9e3Byb3BzLmRpYW1ldGVyfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQnJpY2tzU3dpdGNoO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
}));
cov_1m6kyt7rqi().s[3]++;
var BricksSwitch = function BricksSwitch(props) {
  cov_1m6kyt7rqi().f[0]++;
  cov_1m6kyt7rqi().s[4]++;
  return /*#__PURE__*/_react["default"].createElement(_reactSwitch["default"], {
    checked: props.checked,
    onChange: props.onChange,
    onColor: props.color ? (cov_1m6kyt7rqi().b[0][0]++, props.color) : (cov_1m6kyt7rqi().b[0][1]++, _eero.colors.brand50),
    offColor: _eero.colors.neutrals70,
    uncheckedIcon: props.showYesNoLabel ? (cov_1m6kyt7rqi().b[1][0]++, /*#__PURE__*/_react["default"].createElement(SwitchRight, null, "No")) : (cov_1m6kyt7rqi().b[1][1]++, false),
    checkedIcon: props.showYesNoLabel ? (cov_1m6kyt7rqi().b[2][0]++, /*#__PURE__*/_react["default"].createElement(SwitchLeft, null, "Yes")) : (cov_1m6kyt7rqi().b[2][1]++, false),
    activeBoxShadow: props.color,
    height: 25,
    width: props.showYesNoLabel ? (cov_1m6kyt7rqi().b[3][0]++, 50) : (cov_1m6kyt7rqi().b[3][1]++, 45),
    handleDiameter: props.diameter
  });
};
var _default = exports["default"] = BricksSwitch;